import styled from "@emotion/styled"
import type { RoomBranding } from "../../../../recoil/atoms/room/types"
import { FaPlay } from "react-icons/fa"

export interface StylesProps {
  roomStyles?: RoomBranding
  showLeaveOverlay?: boolean
}

export const Button = styled.button<StylesProps>`
  position: absolute;
  z-index: 10000000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  padding: 10px;
`

export const BigPlayIcon = styled(FaPlay)<StylesProps>`
  color: white;
  font-size: 3rem;
  transform: translate(9%, 0%);
`
